import styled from '@emotion/styled'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead,
  Spinner
} from 'mailup-web-components'
import { modalCopy } from 'Pages/WorkflowsList/recoil/state/modals'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

const StyledSpinner = styled(Spinner)`
  margin-left: 4px;
`

export const ModalActionCopyConfirm = ({
  show,
  handleCancel,
  handleConfirm
}) => {
  const intl = useIntl()
  const { fetchData } = useRecoilValue(modalCopy)

  return (
    <Modal
      data-mu-test='modal-copy-confirm'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick={false}
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ModalConfirmCopy.Title'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.TriggersDetail.WarningCreateCopy'
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handleCancel}
          disabled={fetchData}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Continue' })}
          {fetchData && <StyledSpinner />}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalActionCopyConfirm.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
